import { useCallback } from 'react'

const STORAGE_KEY = 'uniforce-form'
const SUBMITTED_KEY = 'uniforce-submitted'

export const useFormStorage = () => {
  const setFormStorage = useCallback((payload) => {
    if (typeof window === 'undefined') return false
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
  }, [])

  const getFormStorage = useCallback(() => {
    if (typeof window === 'undefined') return false
    const state = sessionStorage.getItem(STORAGE_KEY)
    return JSON.parse(state)
  }, [])

  const cleanFormStorage = useCallback(() => {
    if (typeof window === 'undefined') return false
    sessionStorage.removeItem(STORAGE_KEY)
  }, [])

  const setSubmitted = useCallback(() => {
    if (typeof window === 'undefined') return false
    sessionStorage.setItem(SUBMITTED_KEY, JSON.stringify(true))
  }, [])

  const getSubmitted = useCallback(() => {
    if (typeof window === 'undefined') return false
    const state = sessionStorage.getItem(SUBMITTED_KEY)
    return JSON.parse(state)
  }, [])

  const cleanSubmitted = useCallback(() => {
    if (typeof window === 'undefined') return false
    sessionStorage.removeItem(SUBMITTED_KEY)
  }, [])

  return {
    setFormStorage,
    getFormStorage,
    cleanFormStorage,
    setSubmitted,
    getSubmitted,
    cleanSubmitted,
  }
}
